module.exports = __webpack_public_path__ + "64cc6db7e36d12333bfaa8cfd83288bf.pdf";